import { render, staticRenderFns } from "./event-item-header.vue?vue&type=template&id=3831c044&scoped=true"
import script from "./event-item-header.vue?vue&type=script&lang=js"
export * from "./event-item-header.vue?vue&type=script&lang=js"
import style0 from "./event-item-header.vue?vue&type=style&index=0&id=3831c044&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831c044",
  null
  
)

export default component.exports